export function handleWorkspaceNotFound() {
  if (typeof window === "undefined") return;
  window.location.replace("/404");
}